import { memo } from 'react'
import { Divider, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IProductWarrantyClaim } from '@cbgms/api'
import LicensePlate from '@cbgms/components/form/LicensePlate'
import { useStyles } from '../styles/form.style'
import { useFormikContext } from 'formik'
import { TextField } from '@carsys/form'
import MultilineTextFieldWithPrint from '@cbgms/components/form/MultilineTextFieldWithPrint'
import { convertISOToLocalDate } from '../utils'
import { isEmptyDateTime } from '@cbgms/base/utils/datetime/emptyDates'

const _VehicleDetailsViewSection = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { values: formValues } = useFormikContext<IProductWarrantyClaim>()

  return (
    <Grid item direction='column'>
      <Grid item sx={{ mt: 1 }}>
        <Divider className={classes.widthPercentage} />
      </Grid>

      <Grid item sx={{ my: 3 }}>
        <Typography className={classes.sectionHeader}>{t('productWarrantyClaim.vehicle_related_products')}</Typography>
      </Grid>
      <Grid item container spacing={2}>
        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.license_plate')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <LicensePlate registration={formValues?.FormData.VehicleRelatedProducts.LicensePlate} />
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.chassis_number')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{formValues?.FormData.VehicleRelatedProducts.ChassisNumber}</Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.date_defect')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>
            {isEmptyDateTime(formValues?.FormData.VehicleRelatedProducts.DateDefect)
              ? 'N/A'
              : convertISOToLocalDate(formValues?.FormData.VehicleRelatedProducts.DateDefect)}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.km_reading_at_installation')}:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>
            {formValues?.FormData.VehicleRelatedProducts.KMReadingAtInstallation} {t('productWarrantyClaim.km').toLowerCase()}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography fontWeight='500'>{t('productWarrantyClaim.km_reading_in_case_of_defect')}?</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>
            {formValues?.FormData.VehicleRelatedProducts.KMReadingInCaseOfDefect} {t('productWarrantyClaim.km').toLowerCase()}
          </Typography>
        </Grid>
        <Grid item direction='column' spacing={2} sx={{ width: '100%' }}>
          <Grid item xs sx={{ mt: 1 }}>
            <MultilineTextFieldWithPrint
              className={classes.inputTextAreaField}
              label={t('productWarrantyClaim.note')}
              minRows={4}
              name='Note'
              value={formValues?.Note || ''}
            />
          </Grid>
          <Grid item xs sx={{ mt: 2 }}>
            <TextField
              className={classes.inputTextField}
              required
              label={t('productWarrantyClaim.processedBy')}
              size='small'
              name='ProcessedBy'
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

const VehicleDetailsViewSection = memo(_VehicleDetailsViewSection)
export default VehicleDetailsViewSection
